module.exports = __webpack_public_path__ + "img/Minimal.eebeb28c.svg";